// Hook komentarzy do pozycji oferty klienta - GET /sales-crm/my-offers/:id/positions/:pid/comments

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { ISalesCrmMyOfferComment } from 'api/endpoints/useGetSalesCrmMyOfferComments';

export interface ISalesCrmMyOfferPositionCommentsResponse {
  items: ISalesCrmMyOfferComment[];
}

export const getSalesCrmMyOfferPositionCommentsQueryKey = (
  offerId: string | number,
  positionId: number
) => ['sales-crm', 'my-offer', String(offerId), 'position', positionId, 'comments'] as const;

const getSalesCrmMyOfferPositionComments = (
  offerId: string | number,
  positionId: number
): Promise<ISalesCrmMyOfferPositionCommentsResponse> =>
  axios.get(`/sales-crm/my-offers/${offerId}/positions/${positionId}/comments`);

export const useGetSalesCrmMyOfferPositionComments = (
  offerId: string | number,
  positionId: number,
  options?: UseQueryOptions<ISalesCrmMyOfferPositionCommentsResponse, IError>
) =>
  useQuery<ISalesCrmMyOfferPositionCommentsResponse, IError>(
    getSalesCrmMyOfferPositionCommentsQueryKey(offerId, positionId),
    () => getSalesCrmMyOfferPositionComments(offerId, positionId),
    {
      ...options,
      enabled:
        options?.enabled !== false && String(offerId).trim().length > 0 && positionId > 0
    }
  );
